import * as $echarts from "echarts";
import { specialStyle } from "@/assets/utils/specialStyle";
import * as size from "../utils/chartSize";

const commonLineCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 20)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)

    // 绘制图表
    let option = {
        tooltip: {
            backgroundColor: '#000',
            color: '#000',
            trigger: 'axis',
            axisPointer: {
                // 文字样式
                label: {
                    precision: 2, // 小数点精度
                },
                // 线样式
                lineStyle: {},
            },
            //浮层的文本样式
            textStyle: {
                fontSize: chartSizeB,
                fontFamily: 'Microsoft YaHei',
                color:"#FFF"
            },

            formatter: `{b} <br/> <span style='display:inline-block;margin-right:5px;
            border-radius:10px;width:10px;height:10px;background-color:#42F3FF;'></span> 智慧工厂设备效率: {c0}`
        },
        grid: {
            left: chartSizeK,
            top: chartSizeE,
            bottom: chartSizeI,
            right: chartSizeI,
        },
        xAxis: [{
            data: ['1-3月', '1-6月', '1-9月', '1-12月'],
            boundaryGap: false, // 取消两侧留白
            axisTick: { // 坐标轴刻度
                show: false,
            },
            // 刻度标签配置
            axisLabel: {
                fontSize: chartSizeA,
                color: "#05ebed",
                fontFamily: 'Microsoft YaHei',
                fontWeight: 600,
            },
            // 轴线配置
            axisLine: {
                show: false, // 显示坐标轴线
            },
        },],
        yAxis: [{
            type: 'value',
            axisTick: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: '#2b4e61',
                }
            },
            axisLabel: {
                fontSize: chartSizeA,
                fontFamily: 'Microsoft YaHei',
                color: "rgba(255, 255, 255, 0.65)"
            },
            splitLine: {
                show: false,
            },
        }],
        series: [{
            name: params.series.name,
            data: params.barData1,
            type: 'line',
            smooth: true, // 线性
            showSymbol: false, // 圆点
            lineStyle: {
                width: 2,
                color: "#42F3FF",
            },
            itemStyle: {
                color: "#FFF",
                borderColor: "#42F3FF",
                borderWidth: 1,
            },
            areaStyle: {
                color: {
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                        offset: 0, color: 'rgba(97,228,255,0.3)' // 100% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(97,228,255,0)' // 0% 处的颜色
                    }],
                    global: false // 缺省为 false
                },
                shadowColor: "rgba(53,142,215, 0.9)", //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            }
        },
        // {
        //     name: "阈值线",
        //     type: "line",
        //     markLine: {
        //         symbol: "none", // none为标线两端的样式为无，可更改
        //         lineStyle: {
        //             normal: {
        //                 width: 2,
        //                 color: "#D7D7D7",
        //             },
        //         },
        //         data: [
        //             {
        //                 yAxis: 0,
        //             },
        //         ],
        //         label: {
        //             show: false,
        //         },
        //     },
        // },
    ]
    }
    params.id.setOption(option, true)
}

const doubleLineCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 20)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)


    // 绘制图表
    let option = {
        tooltip: {
            backgroundColor: '#000',
            color: '#000',
            trigger: 'axis',
            axisPointer: {
                // 文字样式
                label: {
                    precision: 2, // 小数点精度
                },
                // 线样式
                lineStyle: {},
            },
            //浮层的文本样式
            textStyle: {
                fontSize: chartSizeB,
                fontFamily: 'Microsoft YaHei',
                color:"#FFF"
            },

            formatter: `{b} <br/> 
            <span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;
            height:10px;background-color:#F7B500;'></span> SMT车间产能效率: {c0} <br/>
            <span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;
            height:10px;background-color:#42F3FF;'></span> 锂电池车间产能效率 : {c1}`,
        },
        grid: {
            left: chartSizeK,
            top: chartSizeE,
            bottom: chartSizeI,
            right: chartSizeI,
        },
        xAxis: [{
            data: ['1-3月', '1-6月', '1-9月', '1-12月'],
            boundaryGap: false, // 取消两侧留白
            axisTick: { // 坐标轴刻度
                show: false,
            },
            // 刻度标签配置
            axisLabel: {
                fontSize: chartSizeA,
                color: "#05ebed",
                fontFamily: 'Microsoft YaHei',
                fontWeight: 600,
            },
            // 轴线配置
            axisLine: {
                show: false, // 显示坐标轴线
            },
        },],
        yAxis: [{
            type: 'value',
            axisTick: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: '#2b4e61',
                }
            },
            axisLabel: {
                fontSize: chartSizeA,
                fontFamily: 'Microsoft YaHei',
                color: "rgba(255, 255, 255, 0.65)"
            },
            splitLine: {
                show: false,
            },
        }],
        series: [{
            data: params.barData1,
            type: 'line',
            showAllSymbol: true,
            smooth: true, // 线性
            symbol: 'circle',
            symbolSize: chartSizeM,
            lineStyle: {
                width: 2,
                color: "#F7B500",
            },
            itemStyle: {
                color: "#FFF",
                borderColor: "#F7B500",
                borderWidth: 1,
            },
            areaStyle: {
                color: {
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                        offset: 0, color: 'rgba(247, 181, 0, 0.2)' // 100% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(247, 181, 0, 0)' // 0% 处的颜色
                    }],
                    global: false // 缺省为 false
                },
                shadowColor: 'rgba(247, 181, 0, 0.2)', //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            }
        }, {
            data:params.barData2,
            type: 'line',
            smooth: true, // 线性
            showAllSymbol: true,
            symbol: 'circle',
            symbolSize: chartSizeM,
            lineStyle: {
                width: 2,
                color: "rgba(66, 243, 255, 1)",
            },
            itemStyle: {
                color: "#FFF",
                borderColor: "rgba(66, 243, 255, 1)",
                borderWidth: 1,
            },
            areaStyle: {
                color: {
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                        offset: 0, color: 'rgba(66, 243, 255, 0.2)' // 100% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(66, 243, 255, 0)' // 0% 处的颜色
                    }],
                    global: false // 缺省为 false
                },
                shadowColor: 'rgba(66, 243, 255, 0.2)', //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            }
        },
        // {
        //     name: "阈值线",
        //     type: "line",
        //     markLine: {
        //         symbol: "none", // none为标线两端的样式为无，可更改
        //         lineStyle: {
        //             normal: {
        //                 width: 2,
        //                 color: "#D7D7D7",
        //             },
        //         },
        //         data: [
        //             {
        //                 yAxis: 0,
        //             },
        //         ],
        //         label: {
        //             show: false,
        //         },
        //     },
        // },
    ]
    }

    params.id.setOption(option, true)
}

export {
    commonLineCharts, doubleLineCharts
}